import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { useState } from "react";

// axisBottom={{
//   orient: "bottom",
//   tickSize: 0,
//   tickPadding: 15,
//   tickRotation: 0,
//   legend: legendX,
//   legendOffset: 40,
//   legendPosition: "middle",
// }}

const Line = ({ data, height, width, legendX, legendY }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const originalColors = {
    "RTS.TAX": colors.greenAccent[500],
    "RTS.FEES": colors.greenAccent[700],
    "PS.TAX": colors.blueAccent[500],
    "PS.FEES": colors.blueAccent[700],
    "CARL.TAX": colors.redAccent[500],
    "CARL.FEES": colors.redAccent[700],
  };
  const [lineColors, setLineColors] = useState(Object.values(originalColors));
  const [selectedId, setSelectedId] = useState();
  return (
    <div style={{ height: height, width: width }} className="chart">
      <ResponsiveLine
        data={data}
        colors={lineColors}
        margin={{ top: 50, right: 150, bottom: 50, left: 60 }}
        xScale={{ type: "point" }}
        yScale={{
          type: "linear",
          min: "0",
          max: "100",
          stacked: false,
          reverse: false,
        }}
        yFormat="0f"
        curve="basis"
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={{
          orient: "left",

          tickSize: 0,
          tickPadding: 20,
          tickRotation: 0,
          legend: legendY,
          legendOffset: -50,
          legendPosition: "middle",

          format: (d) => {
            return `${d}`;
          },
        }}
        theme={{
          textColor: "white",
          axis: {
            ticks: {
              line: {
                stroke: colors.grey[100],
              },
              text: {
                fill: colors.grey[100],
              },
            },
            legend: {
              text: {
                fontSize: 12,
                fill: colors.grey[100],
              },
            },
          },
          tooltip: {
            container: {
              background: colors.grey[800],
              color: "inherit",
              fontSize: "inherit",
              borderRadius: "2px",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
              padding: "5px 9px",
            },
            basic: {
              whiteSpace: "pre",
              display: "flex",
              alignItems: "center",
            },
            table: {},
            tableCell: {
              padding: "3px 5px",
            },
          },
          legends: {
            text: {
              fill: colors.grey[100],
            },
          },
        }}
        pointSize={2}
        pointColor={{ theme: "background" }}
        pointBorderWidth={3}
        pointBorderColor={{ from: "serieColor" }}
        pointLabelYOffset={-12}
        enablePointLabel={false}
        pointLabel={(d) => `${d}%`}
        isInteractive={true}
        useMesh={true}
        legends={[
          {
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: "left-to-right",
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: "circle",
            symbolBorderColor: "rgba(255, 0, 0, .5)",
            effects: [
              {
                on: "hover",
                style: {
                  itemBackground: "rgba(0, 0, 0, .03)",
                  itemOpacity: 1,
                },
              },
            ],

            onClick: (d) => {
              if (d.id === selectedId) {
                setSelectedId(null);
                setLineColors(Object.values(originalColors));
              } else {
                const tempcolors = data.map((series, i) => (series.id === d.id ? originalColors[d.id] : "transparent"));
                console.log(tempcolors);
                console.log(d);
                setLineColors(tempcolors);
                setSelectedId(d.id);
              }
            },
          },
        ]}
        enableGridX={false}
        enableGridY={false}
      />
    </div>
  );
};

export default Line;
